export default __webpack_public_path__ + "locales/fr/ChangePasswordDialog.json?hash=b0b9a78032f5d2761ab04206b5fd3525";